import "./App.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import {
  AppContextProvider,
  guestSecurityService,
  type SecurityServiceContext,
} from "@astroapps/client";
import { RouterProvider } from "@tanstack/react-router";
import { router } from "./routes.tsx";

const security = guestSecurityService;

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <AppContextProvider<SecurityServiceContext> value={{ security }}>
      <RouterProvider router={router} />
    </AppContextProvider>
  </StrictMode>,
);
